import React from "react";
import { motion } from "framer-motion";

function Careers() {
  return (
    <section
      id="careers"
      className="relative min-h-screen py-20 bg-gradient-to-b from-[#E8F3FF] via-[#D6E9FF] to-[#C5E0FF] text-gray-900 overflow-hidden"
    >
      {/* 🔹 Subtle Texture */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/circuits.png')] opacity-10"></div>

      {/* 🔹 Gentle Glow Animation */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-300/10 via-blue-500/10 to-blue-300/10 bg-[length:200%_200%] animate-[gradientFlow_8s_linear_infinite]"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-12 text-center">
        {/* Title */}
        <motion.h2
          className="text-4xl md:text-5xl font-extrabold mb-6 text-blue-700"
          initial={{ y: -50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Careers at SPK MAK
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          className="text-lg text-gray-700 max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Join <span className="font-semibold text-blue-700">SPK MAK Technologies Pvt Ltd</span>{" "}
          and help shape the future of{" "}
          <span className="text-blue-500 font-medium">Robotics & Automation</span>.
        </motion.p>

        {/* 🚧 Development In Progress */}
        <motion.div
          className="bg-white/80 backdrop-blur-md rounded-3xl shadow-xl p-12 max-w-3xl mx-auto border border-blue-100"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            🚧 Careers Page Under Development
          </h3>
          <p className="text-gray-700 text-lg mb-6">
            We’re currently building exciting opportunities for innovators,
            developers, and engineers.
          </p>
          <p className="text-blue-600 font-semibold text-lg mb-8">
            Development is in progress — stay tuned!
          </p>

          <a
            href="mailto:hr@spkmak.com"
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold shadow-md hover:bg-blue-700 transition"
          >
            Share Your Resume
          </a>
        </motion.div>
      </div>

      <style>
        {`
          @keyframes gradientFlow {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
    </section>
  );
}

export default Careers;
